import WorkLogCard from './WorklogCard';

export default WorkLogCard;
